import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import TickSection from "../../components/tickSection/TickSection";

const UsedGearPage = () => {
    return (
        <div>
            <Header />
            <main>
                <TickSection />
                UsedGearPage
            </main>
            
            <Footer />
        </div>
    );
}

export default UsedGearPage;